import React from "react";
import { Outlet } from "react-router-dom";

import Navbar from "components/navigation/Navbar";
import Sidebar from "components/navigation/Sidebar";
import AutoLogoutHandler from "components/common/AutoLogoutHandler";
import FormDraftManager from "components/common/FormDraftManager";

export default function AdminLayout({ isSidebarOpen, toggleSidebar }) {
  return (
    <div className="min-h-screen bg-[var(--lightColor)] text-slate-800">
      <AutoLogoutHandler />
      <FormDraftManager />
      <div className="flex min-h-screen">
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        <div className="flex min-w-0 flex-1 flex-col">
          <Navbar toggleSidebar={toggleSidebar} />
          <div
            className="crm-content min-w-0 flex-1 overflow-x-hidden"
            data-draft-scope="true"
            data-draft-key="page-controls"
          >
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
